import { OptionsHOC } from '..'

const ProductNameHOC = (WrappedComponent) => {
  const ProductName = (parentProps) => {
    const props = {
      ...parentProps,
      productNameSingular: parentProps.getOption(
        'productName.productSingular',
        ''
      ),
      productNamePlural: parentProps.getOption('productName.productPlural', '')
    }
    return <WrappedComponent {...props} />
  }
  return OptionsHOC(ProductName)
}

export default ProductNameHOC
